export const gdprConsentPreferences = {
    GBB_PRIVACY_POLICY: false,
    GBB_TOS: false,
    GBB_NEWSLETTER: false,
    GBB_TICKET_TRIP_REVIEW: false,
}